import { render, staticRenderFns } from "./ContractTab.vue?vue&type=template&id=0700f534&scoped=true"
import script from "./ContractTab.vue?vue&type=script&lang=js"
export * from "./ContractTab.vue?vue&type=script&lang=js"
import style0 from "./ContractTab.vue?vue&type=style&index=0&id=0700f534&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0700f534",
  null
  
)

export default component.exports